//import { DeleteFilled } from '@ant-design/icons';
import { message, Popconfirm, Switch } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import { activateUser, getUserList, User, UserFilter, UserPagedList } from 'api/master';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

let payPagedList: UserPagedList = {
  data: [],
  noOfRecords: 0,
};

type Props = {
  filter: UserFilter;
};

const filterPayload: UserFilter = {};

const UserList = ({ filter }: Props) => {
  const navigate = useNavigate();
  const [pagedList, setPagedList] = useState(payPagedList);
  const [_isLoading, setIsLoading] = useState(false);
  filter.partnerId = sessionStorage.getItem('partnerId')?.toString();
  const [_isfilter, _setFilter] = useState(filterPayload);
  // const [isSearch, setSearch] = useState(false);
  //const [form] = Form.useForm<UserFilter>();
  const [_isReset, _setReset] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  //filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  // const isAdmin = sessionStorage.getItem('isAdmin');

  useEffect(() => {
    setIsLoading(false);
    setPagedList(payPagedList);
    setCurrentPage(1);
    filter.isExtract = false;
    debugger;
    getUserList(filter)
      .then((res) => {
        debugger;
        if (res.data != null) {
          setPagedList(res.data);
        }
        // message.success('Success');
      })
      .finally(() => {
        setIsLoading(true);
      });
  }, [filter]);

  const handleActive = (x: any) => {
    debugger;
    x.isActive = !x.isActive;
    const currentActor = sessionStorage.getItem('userId') || 'Unknown_Admin';
    // Attach to the transient field
    x.updatedBy = currentActor;
    activateUser(x)
      .then((res) => {
        if (res.responseCode == '200') {
          message.success('User updated!');
        }
      })
      .finally(() => {
        //form.resetFields();
        navigate('/master/user');
      });
  };

  // const handleDelete = (_s: any) => {
  //   setIsLoading(true);
  //   debugger;
  //   deleteUser(_s)
  //     .then((res) => {
  //       if (res != null) {
  //         message.success('User Deleted!');
  //       } else {
  //         message.error('Some Error Occured');
  //       }
  //     })
  //     .finally(() => {
  //       debugger;
  //       form.resetFields();
  //       //const a = {};
  //       // handleReset(a);
  //       navigate('/master/user');
  //     });
  // };

  const columns: ColumnsType<User> = [
    {
      key: 'name',
      title: 'Name',
      dataIndex: 'name',
    },
    {
      key: 'emailId',
      title: 'Email Id',
      dataIndex: 'emailId',
    },
    {
      key: 'roleName',
      title: 'Role',
      dataIndex: 'roleName',
    },
    {
      key: 'isActive',
      title: 'Is Active',
      dataIndex: 'isActive',
      ellipsis: true,
      render: (_, record) => (
        <>
          {record.isActive ? (
            <Popconfirm title="Make It InActive?" onConfirm={() => handleActive(record)}>
              {/* <Button type="primary">Active</Button> */}
              <Switch checked />
            </Popconfirm>
          ) : (
            <Popconfirm title="Make It Active?" onConfirm={() => handleActive(record)}>
              {/* <Button type="primary">InActive</Button> */}
              <Switch />
            </Popconfirm>
          )}
        </>
      ),
    },
    // {
    //   key: 'Action',
    //   title: 'Action',
    //   dataIndex: 'action',
    //   ellipsis: true,
    //   render: (_, _record) => (
    //     <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(_record)}>
    //       <a>
    //         <DeleteFilled style={{ fontSize: '16px', marginLeft: '50px' }} />
    //       </a>
    //     </Popconfirm>
    //   ),
    // },
  ];

  const handleChange = (_pagination: any, _filters: any, _sorter: any) => {
    setCurrentPage(_pagination.current);
  };

  const maxWidthPerCell = 200;

  const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <>
      <Table
        loading={!_isLoading}
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={rowKey}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        pagination={{
          pageSize: 10,
          current: currentPage,
        }}
        onChange={handleChange}
      />
    </>
  );
};
export default UserList;
